import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FaFacebookF, FaYoutube, FaTwitter } from "react-icons/fa"; // React Icons for social media
import icons from "../Assests/ICONS.png"
import logo from "../Assests/logo.png";
const Footer = () => {
  return (
    <footer className="footer-container">
      {/* Top Section */}
      <div className="footer-top">
        {/* Logo */}
        <div className="footer-logo">
        <div>
          {/* <img className="footer-imgs" src={icons} alt=""/> */}
        </div>
        <img className="footer-logo" src={logo} alt=""/>
        </div>

        {/* Navigation Links */}
        <nav className="footer-nav">
          {/* <Link to="/">Home</Link> */}
          <Link to="/product">Product's</Link>
          <Link to="/admin-login">Admin</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        {/* Social Media Icons */}
        <div className="footer-social">
          <Link to="/facebook">
            <FaFacebookF />
          </Link>
          <Link to="/youtube">
            <FaYoutube />
          </Link>
          <Link to="/twitter">
            <FaTwitter />
          </Link>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>Copyright © 2025 HospiPharma | Powered by HospiPharma..</p>
      </div>
    </footer>
  );
};

export default Footer;
